import React, {
  useCallback, useEffect, useState
} from 'react';
import { useNavigate } from 'react-router-dom';

import { ModalComponent } from '../../base2';
import {
  AuthUserContext,
  ButtonBar, ErrorMessage,
  PersonInfoDisplay,
  PersonSelect,
  ScreenHeader
} from '../../components';
import {
  useFormData, useIndex, useUpdate
} from '../../hooks';
import { Will } from '../../types';
import { NewBeneficiaryPage } from '../new-beneficiary-page';

import { NewWillContext } from '.';

// eslint-disable-next-line @typescript-eslint/no-unused-vars
export function hasMinorBeneficiaries(will: Will) {
  return false;
}

const formConfig = {
  fields: [
    { 
      id: 'primary-beneficiary', 
      fieldName: 'primary_beneficiary_id',
      type: 'text' as const,
      required: true 
    }
  ]
};

export function NewWillSingleBeneficiaryScreen() {
  const navigate = useNavigate();

  const { user } = React.useContext(AuthUserContext);
  const { will, update: updateWill } = React.useContext(NewWillContext);

  const { data, update: updatePeople } = useIndex('people', { user_id: user?.id });
  const { handleUpdate } = useUpdate('wills');

  const [ showModal, setShowModal ] = useState(false);
  const [ beneficiary, setBeneficiary ] = useState(null);

  const { handleData, errors } = useFormData(formConfig);

  useEffect(() => {
    const beneficiary = people.filter(person => will.singleBeneficiaryId === person.id)[0];

    setBeneficiary(beneficiary);
  }, []);

  const handleBack = useCallback(() => {
    navigate('../asset-distribution');
  }, [ navigate ]);

  const handleNext = useCallback(async () => {
    const payload = handleData();
    
    await handleUpdate(will.id, payload);
    await updateWill();

    if (hasMinorBeneficiaries(will)) {
      return navigate('../minor-beneficiaries');
    }
    
    navigate('../pet-arrangements');
  }, [ handleData, handleUpdate, navigate, updateWill, will ]);

  const handleClickableOption = useCallback(() => {
    setShowModal(true);
  }, []);
  
  const handleClose = useCallback(() => {
    setShowModal(false);
  }, []);

  const handleChange = useCallback(
    (person) => setBeneficiary(person),
    []
  );

  const handleSaveCompletion = useCallback(() => {
    updatePeople();
    setShowModal(false);
  }, [ updatePeople ]);

  const people = data
    .filter((person) => person.linkedUserId !== user?.id);

  const options = people.map((person) => ({
    label: `${person.firstName} ${person.lastName}`,
    ...person
  }));

  const error = errors[0];

  // TODO: add ability to edit beneficiary
  return (
    <div className="new-will-single-beneficiary-screen">
      <ScreenHeader 
        title="Single Beneficiary"
        description="Choose a single individual to receive all assets."
        handleBack={handleBack} 
        steps={6} 
        step={2} 
      />
      
      <PersonSelect
        id="primary-beneficiary"
        handleClickableOption={handleClickableOption}
        handleSelect={handleChange}
        options={options}
        selected={beneficiary}
      />

      <PersonInfoDisplay
        person={beneficiary}
      />

      <ErrorMessage message={error} />
      <ButtonBar handlePrimary={handleNext} />

      <ModalComponent
        closeModal={handleClose}
        contentStyle={{ height: '70%', width: '96%' }}
        showModal={showModal}
      >
        <NewBeneficiaryPage handleSaveCompletion={handleSaveCompletion} />
      </ModalComponent>
    </div>
  );
}





